(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts-simple"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from('.blog-posts-simple__fade-in', {
      opacity: 0,
      x: -50,
      duration: 1,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.blog-posts-simple',
        start: 'top 80%', // Adjust as needed
        toggleActions: 'play none none none', // Play animation when scrolled into view
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comorrow-text-columns-with-images"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let sliderElements = document.querySelectorAll('.comorrow-cols-with-slider .embla');
    sliderElements.forEach((sliderElement) => {
      let slides = sliderElement.querySelectorAll('.embla__slide');
      /*    if (slides.length <= 3) {
        return;
      } */
      const emblaApi = new EmblaCarousel(
        sliderElement,
        {
          align: 'start',
          breakpoints: {
            '(min-width: 768px)': {
              active: slides.length < 4 ? false : true,
            },
          },
        },
        [
          // EmblaCarouselAutoplay({delay: 5000,}),
        ]
      );

      const prevButton = sliderElement.querySelector('.embla__arrow--prev');
      const nextButton = sliderElement.querySelector('.embla__arrow--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          emblaApi.scrollPrev();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          emblaApi.scrollNext();
        });
      }

      // Function to update arrow opacity based on scroll possibility
      const updateArrowOpacity = () => {
        if (prevButton) {
          if (emblaApi.canScrollPrev()) {
            prevButton.classList.remove('embla__arrow--disabled');
          } else {
            prevButton.classList.add('embla__arrow--disabled');
          }
        }
        if (nextButton) {
          if (emblaApi.canScrollNext()) {
            nextButton.classList.remove('embla__arrow--disabled');
          } else {
            nextButton.classList.add('embla__arrow--disabled');
          }
        }
      };

      // Function to update slide visibility using Embla's slidesInView
      const updateSlideVisibility = () => {
        const slides = emblaApi.slideNodes();
        const slidesInView = emblaApi.slidesInView();
        const slidesNotInView = emblaApi.slidesNotInView();

        slides.forEach((slide, index) => {
          if (slidesNotInView.includes(index)) {
            slide.classList.add('out-of-view');
          } else {
            slide.classList.remove('out-of-view');
          }
        });
      };

      // Update opacity on scroll events
      emblaApi.on('select', updateArrowOpacity);
      emblaApi.on('slidesInView', updateSlideVisibility);
      emblaApi.on('reInit', () => {
        updateArrowOpacity();
        updateSlideVisibility();
      });

      // Initial opacity update
      updateArrowOpacity();
      updateSlideVisibility();
    });

    gsap.registerPlugin(ScrollTrigger);
    const parents = Array.from(document.querySelectorAll('.comorrow-cols-with-slider'));
    parents.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.comorrow-cols-with-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-collapsible-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collapsibleContentSections = Array.from(document.querySelectorAll('.education-pdp-collapsible-content'));

    collapsibleContentSections.forEach((section) => {
      const toggleButton = section.querySelector('.education-pdp-collapsible-content__toggle-button');
      const headline = section.querySelector('.education-pdp-collapsible-content__headline');
      const content = section.querySelector('.education-pdp-collapsible-content__content');

      // Only add event listener if toggle button exists (collapsing is not disabled)
      if (toggleButton && content) {
        toggleButton.addEventListener('click', () => {
          toggleButton.classList.toggle('is-open');
          content.classList.toggle('is-open');
        });

        headline.addEventListener('click', () => {
          toggleButton.classList.toggle('is-open');
          content.classList.toggle('is-open');
        });
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('.education-pdp-collapsible-content__video');

    videoContainers.forEach((container) => {
      const playButton = container.querySelector('.education-pdp-collapsible-content__play-button');
      const video = container.querySelector('video');
      const poster = container.querySelector('.education-pdp-collapsible-content__video-poster');
      const loadingSpinner = container.querySelector('.education-pdp-collapsible-content__loading-spinner');

      if (!playButton || !video) {
        return;
      }

      playButton.addEventListener('click', () => {
        video.play();
      });

      video.addEventListener('ended', () => {
        playButton.classList.add('visible');
      });

      function onVideoReady() {
        if (loadingSpinner) {
          loadingSpinner.classList.add('is-hidden');
        }
        playButton.classList.add('visible');
      }

      if (video.readyState >= 2) {
        onVideoReady();
      } else {
        video.addEventListener('loadedmetadata', onVideoReady);
      }

      video.addEventListener('play', () => {
        playButton.classList.remove('visible');
        if (poster) {
          poster.classList.add('is-hidden');
        }
      });

      video.addEventListener('pause', () => {
        playButton.classList.add('visible');
        if (poster) {
          poster.classList.remove('is-hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Carousel init
    let gallerySliders = document.querySelectorAll('.education-pdp-gallery .embla');
    gallerySliders.forEach((sliderElement) => {
      let slides = sliderElement.querySelectorAll('.embla__slide');
      if (slides.length <= 2) return;

      const emblaApi = new EmblaCarousel(
        sliderElement,
        { loop: true, align: 'start' },
        [EmblaCarouselAutoplay({ delay: 5000 })]
      );

      const prevButton = sliderElement.querySelector('.embla__arrow--prev');
      const nextButton = sliderElement.querySelector('.embla__arrow--next');

      if (prevButton) prevButton.addEventListener('click', () => emblaApi.scrollPrev());
      if (nextButton) nextButton.addEventListener('click', () => emblaApi.scrollNext());

      const updateArrows = () => {
        prevButton?.classList.toggle('embla__arrow--disabled', !emblaApi.canScrollPrev());
        nextButton?.classList.toggle('embla__arrow--disabled', !emblaApi.canScrollNext());
      };

      emblaApi.on('select', updateArrows);
      emblaApi.on('reInit', updateArrows);
      updateArrows();
    });

    // Lightbox
    document.querySelectorAll('.education-pdp-gallery').forEach((section) => {
      const sectionEl = section.closest('.shopify-section');
      if (!sectionEl) return;

      const sectionId = sectionEl.id.replace('shopify-section-', '');
      const lightbox = document.getElementById('gallery-lightbox-' + sectionId);
      if (!lightbox) return;

      const lightboxImg = lightbox.querySelector('.education-pdp-gallery__lightbox-img');
      const closeBtn = lightbox.querySelector('.education-pdp-gallery__lightbox-close');
      const prevBtn = lightbox.querySelector('.education-pdp-gallery__lightbox-arrow--prev');
      const nextBtn = lightbox.querySelector('.education-pdp-gallery__lightbox-arrow--next');

      const imageBtns = [...section.querySelectorAll('.education-pdp-gallery__image-btn')];
      let currentIndex = 0;

      const openLightbox = (index) => {
        currentIndex = index;
        const src = imageBtns[currentIndex].dataset.lightboxSrc;
        lightboxImg.classList.add('is-loading');
        lightboxImg.src = src;
        lightboxImg.onload = () => lightboxImg.classList.remove('is-loading');
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        updateNavButtons();
        closeBtn.focus();
      };

      const closeLightbox = () => {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        imageBtns[currentIndex]?.focus();
      };

      const navigate = (direction) => {
        currentIndex = (currentIndex + direction + imageBtns.length) % imageBtns.length;
        const src = imageBtns[currentIndex].dataset.lightboxSrc;
        lightboxImg.classList.add('is-loading');
        lightboxImg.src = src;
        lightboxImg.onload = () => lightboxImg.classList.remove('is-loading');
        updateNavButtons();
      };

      const updateNavButtons = () => {
        const single = imageBtns.length <= 1;
        prevBtn.hidden = single;
        nextBtn.hidden = single;
      };

      imageBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => openLightbox(i));
      });

      closeBtn.addEventListener('click', closeLightbox);
      prevBtn.addEventListener('click', () => navigate(-1));
      nextBtn.addEventListener('click', () => navigate(1));

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') navigate(-1);
        if (e.key === 'ArrowRight') navigate(1);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-in-page-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const navigationList = document.getElementById('dynamic-navigation-list');

    if (!navigationList) return;

    // Find all elements with data-navigation-label attribute
    const navigationElements = document.querySelectorAll('[data-navigation-label]');

    // Create array of navigation objects using map
    const navigationItems = Array.from(navigationElements)
      .map((element, index) => {
        const label = element.getAttribute('data-navigation-label');
        const id = element.id;

        if (!label || !id) return null;

        const listItem = document.createElement('li');
        listItem.className = index === 0 ? 'active' : '';

        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = label;

        // Add smooth scrolling behavior
        link.addEventListener('click', function (e) {
          e.preventDefault();

          // Remove active class from all items
          navigationItems.forEach((item) => {
            if (item && item.listItem) {
              item.listItem.classList.remove('active');
            }
          });

          // Add active class to clicked item
          listItem.classList.add('active');

          // Smooth scroll to target element
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });

        listItem.appendChild(link);
        navigationList.appendChild(listItem);

        return {
          listItem: listItem,
          targetElement: element,
        };
      })
      .filter((item) => item !== null);

    // Remove active state on wheel
    function removeActiveState() {
      navigationItems.forEach((item) => {
        if (item && item.listItem) {
          item.listItem.classList.remove('active');
        }
      });
    }

    // Add wheel event listener to remove active state
    window.addEventListener('wheel', removeActiveState);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-sticky-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // todo: take into account resizing

    if (window.innerWidth < 990) {
      return;
    }

    function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    // create a wrapper for the sticky element so we can end before a specific section e.g. before the text-slider
    const el = document.querySelector('.education-pdp-sticky-product');
    const parent = el.parentElement;
    const children = Array.from(parent.children);
    const outerWrapper = document.createElement('div');
    const innerWrapper = document.createElement('div');
    innerWrapper.className = 'inner-wrapper';
    outerWrapper.appendChild(innerWrapper);
    outerWrapper.className = 'outer-wrapper';

    let foundStickyEnd = false;
    let foundStickyStart = false;
    let childBeforeStickyStart = null;

    for (const child of children) {
      if (child === el) {
        foundStickyStart = true;
      }

      if (foundStickyStart && !foundStickyEnd) {
        innerWrapper.appendChild(child);
        if (child.classList.contains('sticky-end')) {
          foundStickyEnd = true;
        }
      }
      if (!foundStickyStart) {
        childBeforeStickyStart = child;
      }
    }
    insertAfter(outerWrapper, childBeforeStickyStart);

    const elTop = 127 + 16; // 127px is the height of the header, 16px is the dinstance the sticky element should have from top

    window.addEventListener('scroll', function () {
      const wrapperBCR = innerWrapper.getBoundingClientRect();
      const wrapperBottom = wrapperBCR.bottom;
      const wrapperTop = wrapperBCR.top;

      const elementHeight = el.offsetHeight;
      const elBottom = elTop + elementHeight;

      if (wrapperBottom < elBottom) {
        el.classList.remove('stuck-top', 'fixed');
        el.classList.add('stuck-bottom');
      } else if (wrapperTop > elTop) {
        el.classList.remove('stuck-bottom', 'fixed');
        el.classList.add('stuck-top');
      } else {
        el.classList.remove('stuck-top', 'stuck-bottom');
        el.classList.add('fixed');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-trainers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let trainerSliders = document.querySelectorAll('.education-pdp-trainers .embla');
    trainerSliders.forEach((sliderElement) => {
      let slides = sliderElement.querySelectorAll('.embla__slide');
      if (slides.length <= 2) {
        return;
      }
      const emblaApi = new EmblaCarousel(
        sliderElement,
        {
          loop: true,
          align: 'start',
        },
        [
          EmblaCarouselAutoplay({
            delay: 5000,
          }),
        ]
      );

      const prevButton = sliderElement.querySelector('.embla__arrow--prev');
      const nextButton = sliderElement.querySelector('.embla__arrow--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          emblaApi.scrollPrev();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          emblaApi.scrollNext();
        });
      }

      // Function to update arrow opacity based on scroll possibility
      const updateArrowOpacity = () => {
        if (prevButton) {
          if (emblaApi.canScrollPrev()) {
            prevButton.classList.remove('embla__arrow--disabled');
          } else {
            prevButton.classList.add('embla__arrow--disabled');
          }
        }
        if (nextButton) {
          if (emblaApi.canScrollNext()) {
            nextButton.classList.remove('embla__arrow--disabled');
          } else {
            nextButton.classList.add('embla__arrow--disabled');
          }
        }
      };

      // Update opacity on scroll events
      emblaApi.on('select', updateArrowOpacity);
      emblaApi.on('reInit', updateArrowOpacity);

      // Initial opacity update
      updateArrowOpacity();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-video-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('.education-pdp-video');

    videoContainers.forEach((container) => {
      const playButton = container.querySelector('.education-pdp-video__play-button');
      const video = container.querySelector('video');
      const poster = container.querySelector('.education-pdp-video__poster');
      const loadingSpinner = container.querySelector('.education-pdp-video__loading-spinner');

      if (!playButton || !video) {
        return;
      }

      playButton.addEventListener('click', () => {
        video.play();
      });

      video.addEventListener('ended', () => {
        playButton.classList.add('visible');
      });

      function onVideoReady() {
        if (loadingSpinner) {
          loadingSpinner.classList.add('is-hidden');
        }
        playButton.classList.add('visible');
      }

      if (video.readyState >= 2) {
        onVideoReady();
      } else {
        video.addEventListener('loadedmetadata', onVideoReady);
      }

      video.addEventListener('play', () => {
        playButton.classList.remove('visible');
        if (poster) {
          poster.classList.add('is-hidden');
        }
      });

      video.addEventListener('pause', () => {
        playButton.classList.add('visible');
        if (poster) {
          poster.classList.remove('is-hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-2026-about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const readMoreNodes = Array.from(document.querySelectorAll('[data-read-more]'));

    readMoreNodes.forEach((readMore) => {
      const additionalText = readMore.parentElement?.querySelector('[data-additional-text]');
      if (!additionalText) return;

      readMore.addEventListener('click', () => {
        additionalText.classList.toggle('hidden');
        readMore.textContent = additionalText.classList.contains('hidden') ? 'Mehr lesen' : 'Weniger lesen';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-2026-contact-widget"] && !Shopify.designMode) return;
  try {
    
  const angebotSection = document.querySelector('#angebot');
  const widget = document.querySelector('.contact-widget');

  if (!angebotSection || !widget || widget.dataset.widgetMounted === '1') {
    // no-op
  } else {
    widget.dataset.widgetMounted = '1';
    const footer = document.querySelector('[data-landing-footer]');

    let raf = 0;
    let hasShownOnce = widget.classList.contains('is-visible');
    let lastScrollY = window.scrollY || 0;
    let nudgeDistance = 0;

    const NUDGE_MAX_PX = 24;
    const SLIDE_OUT_THRESHOLD_PX = 80;
    const THRESHOLD_BUILD_FACTOR = 0.1;
    const THRESHOLD_START_DELAY_MS = 1000;
    let thresholdDisabledUntil = 0;
    const FOOTER_SLIDEOUT_OFFSET_PX = 120;

    const setNudge = (px) => {
      widget.style.setProperty('--contact-widget-nudge-x', `${px}px`);
    };

    /**
     * Slide-x in px so the avatar's right edge lands `gap` shy of the viewport's right edge
     * (avatar visually inset by the same gap that separates avatar and text in the chip).
     *
     * tx = (viewportRight − gap − restRight) + (chipRight − avatarRight)
     *      └────── slack to gap-inset screen edge ─────┘   └── transform-invariant: same transform on both rects ─┘
     */
    const getSlidePxNeeded = () => {
      const avatar = widget.querySelector('[data-contact-widget-avatar]');
      if (!avatar) return 0;

      const cs = getComputedStyle(widget);
      const rightVal = cs.right;
      const leftVal = cs.left;
      const rightPx = rightVal && rightVal !== 'auto' ? parseFloat(rightVal) : NaN;
      const leftPx = leftVal && leftVal !== 'auto' ? parseFloat(leftVal) : NaN;
      const gapPx = parseFloat(cs.columnGap) || 0;

      const viewportRight = window.innerWidth;
      const targetAvatarRight = viewportRight - gapPx;

      // Resting right edge of the chip (independent of any transform).
      let restRight;
      if (Number.isFinite(rightPx)) {
        restRight = viewportRight - rightPx;
      } else if (Number.isFinite(leftPx)) {
        restRight = leftPx + widget.offsetWidth;
      } else {
        restRight = viewportRight;
      }

      // Both rects carry the same current transform → difference is layout-only.
      const wRect = widget.getBoundingClientRect();
      const aRect = avatar.getBoundingClientRect();
      const chipRightOfAvatar = wRect.right - aRect.right;

      return Math.max(0, Math.round(targetAvatarRight - restRight + chipRightOfAvatar));
    };

    const applySlideVar = () => {
      widget.style.setProperty('--contact-widget-slide-x', `${getSlidePxNeeded()}px`);
    };

    const clearSlideVar = () => {
      widget.style.removeProperty('--contact-widget-slide-x');
    };

    const refreshSlideVar = () => {
      if (widget.classList.contains('is-slid-right')) applySlideVar();
    };

    const update = () => {
      raf = 0;

      const rect = angebotSection.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const shouldShow = rect.top <= viewportHeight / 2;
      const isFirstShow = shouldShow && !hasShownOnce;
      if (shouldShow) hasShownOnce = true;

      widget.classList.toggle('is-visible', hasShownOnce);
      if (isFirstShow) {
        widget.classList.remove('is-slid-right');
        clearSlideVar();
        nudgeDistance = 0;
        setNudge(0);
        lastScrollY = window.scrollY || 0;
        thresholdDisabledUntil = Date.now() + THRESHOLD_START_DELAY_MS;
      }
    };

    const requestUpdate = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    widget.addEventListener('click', (event) => {
      const isVisible = widget.classList.contains('is-visible');
      const isSlidRight = widget.classList.contains('is-slid-right');
      const isFooterHidden = widget.classList.contains('is-footer-hidden');

      if (!isVisible || isFooterHidden) {
        event.preventDefault();
        return;
      }

      if (isSlidRight) {
        event.preventDefault();
        widget.classList.remove('is-slid-right');
        clearSlideVar();
        nudgeDistance = 0;
        lastScrollY = window.scrollY || 0;
        setNudge(0);
      }
    });

    window.addEventListener(
      'scroll',
      () => {
        const currentScrollY = window.scrollY || 0;
        const delta = Math.abs(currentScrollY - lastScrollY);
        lastScrollY = currentScrollY;

        if (hasShownOnce && footer) {
          const footerRect = footer.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const shouldForceHide = footerRect.top <= viewportHeight - FOOTER_SLIDEOUT_OFFSET_PX;

          widget.classList.toggle('is-footer-hidden', shouldForceHide);

          if (shouldForceHide) {
            widget.style.opacity = '0';
            widget.style.pointerEvents = 'none';
            widget.style.setProperty('--contact-widget-y', '140px');
            nudgeDistance = 0;
            setNudge(0);
            requestUpdate();
            return;
          } else {
            widget.style.opacity = '';
            widget.style.pointerEvents = '';
            widget.style.removeProperty('--contact-widget-y');
          }
        }

        // After the widget popped in once, scrolling nudges it slightly.
        // Once a threshold is reached, it slides out fully (CSS transition).
        if (hasShownOnce && !widget.classList.contains('is-slid-right')) {
          if (Date.now() < thresholdDisabledUntil) {
            nudgeDistance = 0;
            setNudge(0);
            requestUpdate();
            return;
          }

          nudgeDistance += delta * THRESHOLD_BUILD_FACTOR;

          if (nudgeDistance >= SLIDE_OUT_THRESHOLD_PX) {
            applySlideVar();
            widget.classList.add('is-slid-right');
            nudgeDistance = 0;
            setNudge(0);
          } else {
            const progress = nudgeDistance / SLIDE_OUT_THRESHOLD_PX;
            setNudge(Math.round(progress * NUDGE_MAX_PX));
          }
        }

        requestUpdate();
      },
      { passive: true }
    );
    const onResize = () => {
      requestUpdate();
      refreshSlideVar();
    };

    window.addEventListener('resize', onResize, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(refreshSlideVar).observe(widget);
    }

    requestUpdate();
    refreshSlideVar();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-featured-image-simple"] && !Shopify.designMode) return;
  try {
    
  // make the header image so high that the h1 is always visible.
  // offsetFromBottom is the distance from the bottom of the h1 to the bottom of the screen.
  const offsetFromBottom = 40;
  document.addEventListener('DOMContentLoaded', function () {
    const featuredImage = document.querySelector('.featured-image-simple');
    const h1 = document.querySelector('h1');

    let previousWidth;

    function handleResize() {
      if (previousWidth && previousWidth === window.innerWidth) {
        // only the height changed, so this is likely caused by minimal ui when scrolling on mobile
        // todo: find a more robust way to handle this
        return;
      }

      if (featuredImage) {
        featuredImage.style.height = '';
        const featuredImageHeight = featuredImage.getBoundingClientRect().height;
        const h1Bottom = h1.getBoundingClientRect().bottom + window.scrollY;

        const excessHeight = h1Bottom - window.innerHeight;

        featuredImage.style.height = `${featuredImageHeight - excessHeight - offsetFromBottom}px`;
      }

      previousWidth = window.innerWidth;
    }

    window.addEventListener('resize', handleResize);

    handleResize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startscreen"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const playButton = document.querySelector('.startscreen__play-button');
    const video = document.querySelector('.startscreen__video video');
    const poster = document.querySelector('.startscreen__video-poster');
    const loadingSpinner = document.querySelector('.startscreen__loading-spinner');

    playButton.addEventListener('click', () => {
      video.play();
    });

    video.addEventListener('ended', () => {
      playButton.classList.add('visible');
    });

    function onVideoReady() {
      loadingSpinner.classList.add('is-hidden');
      playButton.classList.add('visible');
    }

    if (video.readyState >= 2) {
      onVideoReady();
    } else {
      video.addEventListener('loadedmetadata', onVideoReady);
    }

    video.addEventListener('play', () => {
      playButton.classList.remove('visible');
      poster.classList.add('is-hidden');
    });

    video.addEventListener('pause', () => {
      playButton.classList.add('visible');
      poster.classList.remove('is-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let teamSliderSections = document.querySelectorAll('[data-section-type="team-slider"]');
    teamSliderSections.forEach((section) => {
      let splideElement = section.querySelector('.splide');
      let splide = new Splide(splideElement, {
        type: 'loop', // Infinite loop
        perPage: 3,
        perMove: 1, // Move one slide at a time
        pagination: false, // Disable pagination
        speed: 600, // Animation speed
        rewind: true, // Rewind to the beginning if needed
        gap: '20px',
        breakpoints: {
          1500: {
            perPage: 2,
          },
          767: {
            perPage: 1,
          },
        },
      }).mount();

      // Custom arrow controls
      section.querySelector('.team-slider__arrow--prev').addEventListener('click', function () {
        splide.go('<');
      });

      section.querySelector('.team-slider__arrow--next').addEventListener('click', function () {
        splide.go('>');
      });
    });

    gsap.registerPlugin(ScrollTrigger);
    teamSliderSections.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.team-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const textSliderSections = document.querySelectorAll('.text-slider');

    textSliderSections.forEach((section) => {
      const splideElement = section.querySelector('.splide');
      const slides = splideElement.querySelectorAll('.splide__slide');

      if (splideElement) {
        const splide = new Splide(splideElement, {
          direction: 'ttb', // top-to-bottom for vertical scrolling
          height: 351,
          perMove: 1,
          pagination: false,
          arrows: false,
          speed: 600,
          gap: '20px',
          autoplay: true,
          interval: 3000,
          pauseOnHover: true,
          focus: 'center',
          wheel: slides.length > 1 ? true : false,
          releaseWheel: true,
          rewind: true,
          wheelSleep: 800,
          wheelMinThreshold: 5,

          breakpoints: {
            990: {
              direction: 'ltr',
              wheel: false,
              loop: true,
              rewind: false,
              height: 'auto',
            },
          },
        });

        splide.mount();

        const dots = section.querySelectorAll('.pagination-dots .dot');

        splide.on('move', function (newIndex) {
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === newIndex);
          });
        });

        // we dont want to rewind when wheeling
        // so we disable it when autoplay is paused
        splide.on('autoplay:pause', function () {
          splide.options = {
            rewind: false,
          };
        });

        splide.on('autoplay:play', function () {
          splide.options = {
            rewind: true,
          };
        });

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === 0);

          dot.addEventListener('click', function () {
            splide.go(index);
          });
        });
      }
    });

    gsap.registerPlugin(ScrollTrigger);
    textSliderSections.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.text-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
